var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResourceCenter1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.1914 11.4818C17.9229 11.4818 20.1354 9.26931 20.1354 6.53775C20.1354 3.80619 17.9229 1.59375 15.1914 1.59375C12.4598 1.59375 10.2474 3.80619 10.2474 6.53775C10.2474 9.26931 12.4598 11.4818 15.1914 11.4818ZM15.1914 4.06575C16.551 4.06575 17.6634 5.17815 17.6634 6.53775C17.6634 7.89735 16.551 9.00975 15.1914 9.00975C13.8318 9.00975 12.7194 7.89735 12.7194 6.53775C12.7194 5.17815 13.8318 4.06575 15.1914 4.06575ZM15.1914 14.6336C12.2744 11.9144 8.36866 10.2458 4.06738 10.2458V23.8418C8.36866 23.8418 12.2744 25.5103 15.1914 28.2296C18.1083 25.5227 22.0141 23.8418 26.3154 23.8418V10.2458C22.0141 10.2458 18.1083 11.9144 15.1914 14.6336ZM23.8434 21.5304C20.7163 21.9507 17.7499 23.1372 15.1914 25.016C12.6452 23.1372 9.66646 21.9383 6.53938 21.5181V12.9279C9.13498 13.3976 11.5452 14.5965 13.5104 16.4258L15.1914 18.0078L16.8723 16.4381C18.8376 14.6088 21.2478 13.4099 23.8434 12.9402V21.5304Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceCenter1);
export default __webpack_public_path__ + "static/media/resourceCenter1.90598452bc329728e249c9dfdbe0f80c.svg";
export { ForwardRef as ReactComponent };